import stickybits from 'stickybits';
import Glide from '@glidejs/glide';
import { siblings } from '@glidejs/glide/src/utils/dom';


export default {
  init() {

    const classes = {
      glideSlideNextActive: 'glide__slide--next-active',
    }

    const selectors = {
      glideSlideNextActive: '.glide__slide--next-active',
      glideTrack: '.review-glider .glide__track',
    }

    function ResizeSlider(Glide, Components, Events) {
      const Component = {
        mount() {
          this.changeActiveSlide();
          this.updateTrackHeight();
        },

        changeActiveSlide() {
          let slide = Components.Html.slides[Glide.index];
          slide.classList.add(classes.glideSlideNextActive);

          siblings(slide).forEach((sibling) => {
            sibling.classList.remove(classes.glideSlideNextActive);
          });
        },

        updateTrackHeight() {
          console.log('update track height');

          const activeSlide = document.querySelector(
            selectors.glideSlideNextActive
          );
          const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;

          const glideTrack = document.querySelector(selectors.glideTrack);
          const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

          console.log(`Glide track height:${glideTrackHeight}`)

          console.log(`Active slide: ${activeSlide} activeSlideHeight: ${activeSlideHeight}`)

          if (activeSlideHeight !== glideTrackHeight) {
            glideTrack.style.height = `${activeSlideHeight}px`;
          }
        },
      };

      Events.on('run', () => {
        Component.changeActiveSlide();
        Component.updateTrackHeight();
      });

      return Component;
    }

    const slider = new Glide('.review-glider');

    if (document.body.contains(document.querySelector('.review-glider'))) {
      slider.mount({
        ResizeSlider: ResizeSlider,
      });
    }

    if (document.body.contains(document.querySelector('.glider'))) {
      new Glide('.glider', {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        breakpoints: {
          1200: {
            perView: 2,
          },
          1024: {
            perView: 1,
          },
        },
      }).mount();
    }


    // Sticky the header
    stickybits('.banner', {useStickyClasses: true});

    const mmClass = 'mm-open',
      body = document.body;


    // Toggle for mobile menu hamburger
    const mobileMenu = () => {
      const el = document.querySelector('.mobileMenu-toggle');
      let scrollPos;
      el.onclick = (event) => {
        event.preventDefault();
        body.classList.toggle(mmClass);
        if (body.classList.contains(mmClass)) {
          scrollPos = window.scrollY;
          window.scrollTo({
            top: 0,
          });
        } else {
          window.scrollTo({
            top: scrollPos,
          });
        }
      }
    }
    mobileMenu();
  },
  finalize() {},
};
